fp.ListManager = fp.Class.extend({
    construct: function (options) {
        options = _.getObject(options);
        this.type = options.type || 'list';
        this.lists = [];
        this.selectedList = $.extend({}, fp.defaultList);
        this.options = $.extend({
            type: 'list',
            limit: 1,
            listItemSort: 'created_at!',
            listIdField: 'shopping_list_id',
            listService: fpService.shoppingListService,
            listItemService: fpService.shoppingListItemService
        }, options);

        var self = this;

        this.events = _.concat(this.events, [{
            name: fp.events.LIST_ITEM_ADD,
            value: function(event, payload) {
                if(payload.listManager.type != self.type) return;
                if(payload.listManager.getList().id != self.getList().id) return;
                if(event.handled) return;
                event.handled = true;
                self.listItemAdd(event, payload);
            }
        }, {
            name: fp.events.LIST_ITEM_INCREMENT,
            value: function(event, payload){
                if(payload.listManager.type != self.type) return;
                if(payload.listManager.getList().id != self.getList().id) return;
                if(event.handled) return;
                event.handled = true;
                self.listItemIncrement(event, payload);
            }
        }, {
            name: fp.events.LIST_ITEM_REMOVE,
            value: function(event, payload){
                if(payload.listManager.type != self.type) return;
                if(payload.listManager.getList().id != self.getList().id) return;
                if(event.handled) return;
                event.handled = true;
                self.listItemRemove(event, payload);
            }
        }, {
            name: fp.events.LIST_ITEM_CHANGED,
            value: function(event, payload){
                if(!payload.itemChangeSuccess) return;
                if(payload.listManager.type != self.type) return;
                if(payload.listManager.getList().id != self.getList().id) return;
                if(event.handled) return;
                event.handled = true;
                self.listItemChanged(event, payload);
            }
        }, {
            name: fp.events.LIST_ITEM_UPDATE,
            value: function(event, payload){
                if(payload.listManager.type != self.type) return;
                if(payload.listManager.getList().id != self.getList().id) return;

                if(event.handled) return;
                event.handled = true;
                self.listItemUpdate(event, payload);
            }
        }]);

        _.each(this.events, function(item) {
            fp.on(item.name, item.value);
        });
    },
    getList: function (id) {
        if (!id) return this.selectedList;
    
        return _.findWhere(this.lists, {id: id});
    },
    getLists: function () {
        return this.lists;
    },
    getSelectedList: function (refresh, payload, options, force) {
        if (!refresh) return $.Deferred().resolve(this.selectedList);
    
        //var self = this;
        //return fpUtil.delayPromise(null, 1000 * 20)
        //    .then(function() {
        //        return self.refreshList(refresh, payload, options);
        //    });
    
        return this.refreshList(true, payload, options, force);
    },
    setSelectedList: function (list) {
        if (_.isObject(list)) {
            if (this.selectedList.id == list.id) {
                if (this.selectedList.items) list.items = this.selectedList.items;
            }
            if (list.id !== fp.defaultList.id && !this.getList(list.id)) this.lists.push(list);
        }
        else {
            var id = S.getString(list, fp.defaultList.id);
            list = null;
            if (id !== fp.defaultList.id) list = this.getList(id);
        }
    
        if (!list) list = this.lists[0] || $.extend({}, fp.defaultList);
    
        list.items = _.getArray(list.items);
    
        this.selectedList = list;
        fpUi.ListManager.setListDefaults(this.selectedList);
    },
    refreshList: function (refreshItems, payload, options) {
        return $.when();
    },
    listActivate: function() {
        return $.when();
    },
    refreshListItems: function (updateItems, disableTrigger) {
        if (!(this.selectedList && this.selectedList.id)) {
            return $.when();
        }
        updateItems = fpUtil.getBoolean(updateItems, true);
    
        var self = this,
            payload = {
                //fields: 'id,product,item_total,item_total_display,shopping_list_id,product_id,quantity,note,is_crossed,varieties,substitution_type_id,quantity_indicator,status',
                limit: -1,
                sort: this.options.listItemSort
            };
        payload[this.options.listIdField] = this.selectedList.id;

        return this.options.listItemService
            .get(this.applyPayloadOrderParams(payload, {intent: 'listItems'}))
            .then(function (resp) {
                var items = _.getArray(resp.items);
                if (updateItems) self.selectedList.items = items;

                if (!disableTrigger) fp.trigger(self.options.type == 'order' ? fp.events.ORDER_LIST_ITEMS_REFRESHED : fp.events.LIST_ITEMS_REFRESHED, {
                    listManager: self,
                    list: self.selectedList
                });
    
                return items;
            });
    },
    getItem: function (id, opts) {
        if (!id) return;
        if (fpUtil.isNewItem(id)) return;
    
        var options = {
            isProductId: false,
            isGenericName: false,
            multiple: false
        };
    
        if (_.isBoolean(opts)) options.isProductId = opts;
        else $.extend(options, opts);
    
        if (options.isGenericName && !fp.store.allow_generic_item) return;
    
        id = id.toString();
    
        var find = options.multiple ? _.filter : _.find,
            matchVariety = _.isObject(options.varieties),
            hasVariety = matchVariety && _.size(options.varieties) > 0,
            isMatch;
    
        return find(this.selectedList.items, function (item) {
            if (options.isProductId) isMatch = (item.product && S(item.product.id).eq(id));
            else if (options.isGenericName) isMatch = S(item.note).eq(id);
            else isMatch = S(item.id).eq(id);
    
            if (!isMatch) return false;
            if (!matchVariety) return true;
    
            //if list item's product does not have varieties do not match options.varieties
            if (!item.product) return false;
            if (!_.size(item.product.varieties)) return false;
    
            if (!hasVariety && !_.size(item.varieties)) return true;
    
            return _.isEqual(item.varieties, options.varieties);
        });
    },
    listItemAdd: function (event, payload) {
        payload = _.getObject(payload);
        var item = payload.item,
            formValues = payload.formValues,
            errorSelector = payload.errorSelector,
            parentModule = payload.parentModule;
    
        if (!_.isObject(item) || fpUtil.isNewItem(this.selectedList.id)) {
            return $.when();
        }
    
        var self = this,
            isGeneric = fpUtil.isNewItem(item.id),
            quantityInitial = fp.ui.ListManager.getQuantityInitial(item),
            quantity = fpUtil.getFloat(item.__product_quantity),
            listName = payload.listName,
            listPosition = payload.listPosition,
            listItem;
    
        if (quantity < quantityInitial) quantity = quantityInitial;
    
        listItem = this.getItem(item.id, isGeneric);
    
        if (listItem && !isGeneric) {
            if (listItem.is_crossed) listItem.quantity = 0;
            fp.trigger(fp.events.LIST_ITEM_INCREMENT, {
                listManager: this,
                item: listItem,
                quantity: quantity
            });
            return $.when();
        }

        payload = {};

        var listId = self.selectedList.id !== fp.defaultList.id ? self.selectedList.id : undefined,
            promiseUserProducts;

        if (!listItem) listItem = {};

        if (isGeneric) $.extend(payload, item);
        $.extend(true, payload, formValues, {
            id: listItem.id,
            product_id: item.id,
            quantity: quantity
        });
        payload[this.options.listIdField] = listId;

        if (!isGeneric) listItem.product_id = item.id;
        listItem.id = item.id || fpUtil.getNewItemId();
        if (fpUtil.isNewItem(payload.product_id)) delete payload.product_id;

        var eventPayload = {
            listManager: self,
            item: listItem,
            itemChangeType: fpConstants.listItemChangeType.ADD,
            itemChangedQuantity: quantity,
            previousQuantity: 0,
            oldListItemId: listItem.id,
            listName: listName,
            listPosition: listPosition,
            parentModule: parentModule
        };

        fp.trigger(fp.events.LIST_ITEM_BEFORE_CHANGE, eventPayload);

        //if varieties are enabled we need to explicitly clear notes
        if (_.size(item.varieties)) {
            promiseUserProducts = $.Deferred().promise();
            fpService.userProductService
                .create({
                    product_id: payload.product_id,
                    note_clear: true
                })
                .always(promiseUserProducts.deferred().resolve);
        }

        return $.when(promiseUserProducts)
            .then(function () {
                if(listName) {
                    payload.other_attributes = $.extend(payload.other_attributes, {
                        listName: listName,
                        listPosition: listPosition
                    });
                }

                if(_.size(payload.other_attributes)) {
                    payload.other_attributes = JSON.stringify(payload.other_attributes);
                }

                return self.options.listItemService
                    .create(self.applyPayloadOrderParams(payload, {intent: 'listItemsChange'}), {errorSelector: errorSelector})
                    .then(function (resp) {
                        $.extend(true, listItem, resp);
                        self.selectedList.items.unshift(listItem);

                        var promiseUpdate;
                        if(eventPayload.note) {
                            promiseUpdate = $.Deferred().promise();
                            self.options.listItemService
                                .update({
                                    id: listItem.id,
                                    product_id: item.id,
                                    note: eventPayload.note
                                })
                                .done(function (resp) {
                                    _.empty(listItem);
                                    $.extend(true, listItem, resp);
                                })
                                .always(promiseUpdate.deferred().resolve);
                        }

                        return $.when(promiseUpdate)
                            .then(function (resp) {
                                eventPayload.itemChangeSuccess = true;
        
                                if (self.type == 'list' && listItem.shopping_list_id && self.selectedList.id === fp.defaultList.id) {
                                    var always = function (list) {
                                        if (list) return eventPayload.listManager.setSelectedList(list);
                                    };
        
                                    return self.listActivate(null, listItem.shopping_list_id, true).then(always, always);
                                }
                            });
                    })
                    .always(function () {
                        fp.trigger(fp.events.LIST_ITEM_CHANGED, eventPayload, null, true);
                    });
            });
    },
    listItemIncrement: function (event, payload) {
        payload = _.getObject(payload);
        var item = payload.item,
            increment = payload.increment,
            hasQuantity = _.has(payload, 'quantity'),
            errorSelector = payload.errorSelector,
            parentModule = payload.parentModule,
            listName = payload.listName,
            listPosition = payload.listPosition;
    
        if (!item) return;
        item = _.isObject(item) ? this.getItem(item.id) : this.getItem(item, true);
        if (!item) return;
    
        var quantity,
            quantityInitial = fp.ui.ListManager.getQuantityInitial(item);

        if (hasQuantity) {
            quantity = payload.quantity;
            if (quantity >= 1) quantity = fpUtil.getFloat(quantity);
    
            var product = fpUtil.getProduct(item);
            if (!(product && product.is_weight_required)) {
                quantity = Math.round(quantity);
            }
    
            if (item.product.quantity_step >= 1) increment = quantity < 1 ? -1 : 1;
            else if(!_.has(payload, 'increment')) increment = quantity;
        }
        else quantity = item.quantity || 0;

        if(_.has(payload, 'increment')) {
            increment = fp.ui.ListManager.getIncrement(item) * (increment < 1 ? -1 : 1);
            if(fpUtil.isFloat(increment) || fpUtil.isFloat(quantity)) {
                //fix floating point math
                var precision1 = S(increment.toString().split('.')[1]).length,
                    precision2 = S(quantity.toString().split('.')[1]).length;
                quantity = fp.numeralInstance
                    .set(quantity + increment).round(precision1 > precision2 ? precision1 : precision2)
                    .value();
            }
            else quantity += increment;
        }

        if (quantityInitial && quantity < quantityInitial) {
            if (increment > 0) {
                quantity = quantityInitial;
            }
            else {
                fp.trigger(fp.events.LIST_ITEM_REMOVE, {
                    listManager: this,
                    item: item
                });
                return;
            }
        }

        var eventPayload = {
            listManager: this,
            item: item,
            itemChangeType: fpConstants.listItemChangeType.INCREMENT,
            itemChangedQuantity: quantity,
            previousQuantity: item.quantity,
            parentModule: parentModule,
            listName: listName,
            listPosition: listPosition
        };
        fp.trigger(fp.events.LIST_ITEM_BEFORE_CHANGE, eventPayload);
    
        if (quantity >= 1) quantity = quantity.toFixed(2);

        payload = {
            id: item.id,
            quantity: quantity
        };

        if(listName) {
            payload.other_attributes = $.extend(payload.other_attributes, {
                listName: listName,
                listPosition: listPosition
            });
        }

        if(_.size(payload.other_attributes)) {
            payload.other_attributes = JSON.stringify(payload.other_attributes);
        }

        this.options.listItemService
            .update(this.applyPayloadOrderParams(payload, {intent: 'listItemsChange'}), {errorSelector: errorSelector})
            .done(function (resp) {
                _.empty(item);
                $.extend(true, item, resp);
                eventPayload.itemChangeSuccess = true;
            })
            .always(function () {
                fp.trigger(fp.events.LIST_ITEM_CHANGED, eventPayload, null, true);
            });
    },
    listItemRemove: function (event, payload) {
        if (!payload.item) return;

        var item = payload.item,
            listName = payload.listName,
            listPosition = payload.listPosition,
            eventPayload = {
                listManager: this,
                item: item,
                itemChangeType: fpConstants.listItemChangeType.REMOVE,
                itemChangedQuantity: item.quantity,
                previousQuantity: item.quantity,
                parentModule: payload.parentModule,
                listName: listName,
                listPosition: listPosition
            };

        if (fpUtil.isNewItem(item.id)) {
            fp.trigger(fp.events.LIST_ITEM_CHANGED, eventPayload, null, true);
            return;
        }
    
        item = _.isObject(item) ? this.getItem(item.id) : this.getItem(item, true);

        if (!item/* || item.quantity <= 0*/) return;
    
        eventPayload.item = item;
        fp.trigger(fp.events.LIST_ITEM_BEFORE_CHANGE, eventPayload);
    
        // var spill = _.random(0, 1);
        // spill = 1;
        // if(spill) {
        //     payload = {spill: spill};
        // }
        var self = this,
            subscription = item.my_current_subscription;

        payload = {
            id: item.id
        };

        if(listName) {
            payload.other_attributes = $.extend(payload.other_attributes, {
                listName: listName,
                listPosition: listPosition
            });
        }

        if(_.size(payload.other_attributes)) {
            payload.other_attributes = JSON.stringify(payload.other_attributes);
        }

        var promise = this.options.listItemService
            .post(this.applyPayloadOrderParams(payload, {intent: 'listItemsChange'}), {childServiceCall: 'delete'});

        //remove subscription if it exists
        if(_.size(subscription)) {
            promise
                .then(function() {
                    return fpService.userProductSubscriptionService
                        .delete(fp.user.id, {
                            childServiceCall: subscription.id
                        });
                });
        }

        promise = promise
            .done(function () {
                item.quantity = item.quantity_indicator = 0;
                _.removeWhere(self.selectedList.items, {id: item.id});
                eventPayload.itemChangeSuccess = true;
            })
            .always(function () {
                fp.trigger(fp.events.LIST_ITEM_CHANGED, eventPayload, null, true);
            });
    },
    listItemChanged: function (event, payload) {
        if (payload.itemChangeType == -1) return;
    
        var self = this,
            isNew = fpUtil.isNewItem(payload.item.id),
            refreshItems = false,
            listItemChangeType = fpConstants.listItemChangeType;
    
        if (isNew) payload.itemChangeType = listItemChangeType.REMOVE;
    
        switch (payload.itemChangeType) {
            case listItemChangeType.ADD:
            case listItemChangeType.INCREMENT:
            case listItemChangeType.CHECK_TOGGLE:
                refreshItems = true;
                break;
            case listItemChangeType.REMOVE:
                payload.item.quantity = 0;
                refreshItems = true;
                break;
            default:
                break;
        }

        $.when.apply($, payload.clientParams.promises)
            .always(function (resp) {
                if (resp != 'abort') {
                    self.refreshList(refreshItems);
                }
            });

    },
    listItemUpdate: function (event, payload) {
        let item = payload.item;
        //debugger;
        if (!_.isObject(item)) return;
        if (item.id) item = this.getItem(item.id);
        if (!item && payload.item.product_id) item = this.getItem(payload.item.product_id, true);
        if (!item) return;
    
        let formValues = payload.formValues,
            eventPayload = {
                listManager: this,
                item: item,
                itemChangeType: payload.listItemChangeType || fpConstants.listItemChangeType.UPDATE,
                parentModule: payload.parentModule
            },
            promise;
            
        payload = fpUtil.getChanged(payload.item, item);
    
        fp.trigger(fp.events.LIST_ITEM_BEFORE_CHANGE, eventPayload);

        $.extend(true, payload, formValues, {
            id: item.id
        });

        if(_.size(payload) > 1) {
            if(_.size(payload.other_attributes)) {
                payload.other_attributes = JSON.stringify(payload.other_attributes);
            }

            promise = this.options.listItemService
                .update(this.applyPayloadOrderParams(payload))
                .done(function (resp) {
                    _.empty(item);
                    $.extend(true, item, resp);
                    eventPayload.itemChangeSuccess = true;
                });
        }

        $.when(promise)
            .always(function () {
                fp.trigger(fp.events.LIST_ITEM_CHANGED, eventPayload, null, true);
            });
    },
    applyPayloadOrderParams: function (payload) {
        return payload;
    },
    destroy: function () {
        _.each(this.events, function (item) {
            fp.off(item.name, item.value);
        });
    }
});